import create from "zustand";
import produce from "immer";

const STORE = {
  filePreviewConfig: {}
};
const createWithImmer = (storeCreator) =>
  create((originalSet, originalGet) =>
    storeCreator((fn) => originalSet(produce(fn)), originalGet)
  );

export const useFilePreviewStore = createWithImmer((setState, getState) => ({
  ...STORE,
  setFlowConfig: (data) => {
    let filePreviewData = { ...getState().filePreviewConfig };
    filePreviewData[data.flowId] = data;
    setState((state) => {
      return { filePreviewConfig: filePreviewData };
    });
  },
  removeFlowConfig: (modelId) => {
    let filePreviewData = { ...getState().filePreviewConfig };
    filePreviewData[modelId] &&
      Reflect.deleteProperty(filePreviewData, modelId);
    setState((state) => {
      return {
        filePreviewConfig: filePreviewData
      };
    });
  },
  reset: (data) => {
    setState((state) => {
      return { ...STORE };
    });
  }
}));
